import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';

const GuaranteesModal = ({
  setOpenFormuleModal,
  openFormuleModal,
  contract
}) => {
  const { t } = useTranslation();

  const dataSource = [
    {
      guarantees: "Responsabilité civile propriétaire d'immeuble",
      subscribed_option: contract?.g1231_property_owner_civil_liability
    },
    {
      guarantees: 'Défense pénale et recours suite à accident (DPRSA)',
      subscribed_option:
        contract?.g1231_criminal_defense_recourse_following_accident
    },
    {
      guarantees: 'Protection juridique',
      subscribed_option: contract?.g1231_juridic_protection
    },
    {
      guarantees: 'Catastrophes naturelles',
      subscribed_option: contract?.g1231_natural_disasters
    },
    {
      guarantees: 'Risques technologiques',
      subscribed_option: contract?.g1231_technological_risks
    },
    {
      guarantees: 'Incendie et risques annexes',
      subscribed_option: contract?.g1231_fire_related_risks
    },
    {
      guarantees: 'Attentats',
      subscribed_option: contract?.g1231_attacks
    },
    {
      guarantees: 'Garéat',
      subscribed_option: contract?.g1231_gareat
    },
    {
      guarantees: 'Responsabilité civile syndicale',
      subscribed_option: contract?.g1231_union_civil_liability
    },
    {
      guarantees: 'Tempêtes, grêle, poids de la neige',
      subscribed_option: contract?.g0230_storms_hail_heavy_snow
    },
    {
      guarantees: 'Effondrement',
      subscribed_option: contract?.g0230_collapse
    },
    {
      guarantees: 'Vol',
      subscribed_option: contract?.g0230_theft
    },
    {
      guarantees: 'Dommages électriques',
      subscribed_option: contract?.g0230_electrical_damage
    },
    {
      guarantees: 'Bris de glace',
      subscribed_option: contract?.g0030_broken_glass
    },
    {
      guarantees: 'Dégâts des eaux',
      subscribed_option: contract?.g0030_water_damage
    },
    {
      guarantees: 'Vandalisme',
      subscribed_option: contract?.g0030_vandalism
    }
  ];

  const columns = [
    {
      title: t('contracts.form.guarantees'),
      dataIndex: 'guarantees',
      key: 'guarantees'
    },
    {
      title: t('contracts.form.subscribed_option'),
      dataIndex: 'subscribed_option',
      key: 'subscribed_option',
      render: (subscribed_option) =>
        subscribed_option ? (
          <CheckOutlined style={{ color: 'green' }} />
        ) : (
          <CloseOutlined style={{ color: 'red' }} />
        )
    }
  ];

  return (
    <Modal
      title={`${t('contracts.form.guarantee_type_modal_title')}`}
      open={openFormuleModal}
      onOk={() => setOpenFormuleModal(false)}
      onCancel={() => setOpenFormuleModal(false)}
      width={500}
    >
      <Table dataSource={dataSource} columns={columns} />
    </Modal>
  );
};

GuaranteesModal.propTypes = {
  setOpenFormuleModal: PropTypes.func.isRequired,
  openFormuleModal: PropTypes.bool.isRequired,
  contract: PropTypes.shape({
    g0030_vandalism: PropTypes.bool,
    g0030_water_damage: PropTypes.bool,
    g0030_broken_glass: PropTypes.bool,
    g0230_electrical_damage: PropTypes.bool,
    g0230_theft: PropTypes.bool,
    g0230_collapse: PropTypes.bool,
    g0230_storms_hail_heavy_snow: PropTypes.bool,
    g1231_union_civil_liability: PropTypes.bool,
    g1231_gareat: PropTypes.bool,
    g1231_attacks: PropTypes.bool,
    g1231_fire_related_risks: PropTypes.bool,
    g1231_technological_risks: PropTypes.bool,
    g1231_natural_disasters: PropTypes.bool,
    g1231_juridic_protection: PropTypes.bool,
    g1231_criminal_defense_recourse_following_accident: PropTypes.bool,
    g1231_property_owner_civil_liability: PropTypes.bool
  })
};

GuaranteesModal.defaultProps = {
  contract: []
};

export default GuaranteesModal;
